import axios from "axios";
import {refreshTokenUrl} from "./URL";
import {logOut} from "./action/login.action";
import {connect} from "react-redux";

const axiosInstanceFtth = axios.create();

axiosInstanceFtth.interceptors.request.use(
    config => {
        const accessToken = localStorage.getItem('slt_ftth_accessToken')
        if (accessToken) {
            config.headers['Authorization'] = 'bearer ' + accessToken;
        }
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.headers['X-IBM-Client-Id'] = 'b7402e9d66808f762ccedbe42c20668e'; // prod
        //config.headers['X-IBM-Client-Id'] = 'e8282d66-d974-4b26-bafd-be1b0cf1f55f';
        return config;
    },
    error => {
        Promise.reject(error)
    });


axiosInstanceFtth.interceptors.response.use((response) => {
    return response
}, function (error) {

    const originalRequest = error.config;
    const accessToken = localStorage.getItem('slt_ftth_accessToken')
    const refreshToken = localStorage.getItem('slt_ftth_refreshToken')

    if (accessToken && refreshToken) {

        if (error.response.status === 401 && originalRequest.url ===
            refreshTokenUrl) {

            logOut()
            localStorage.removeItem('slt_ftth_accessToken')
            localStorage.removeItem('slt_ftth_refreshToken')
            localStorage.removeItem('userImage')
            window.location.reload()

        } else if (error.response.status === 401 && !originalRequest._retry) {

            originalRequest._retry = true;

            const refreshToken = localStorage.getItem('slt_ftth_refreshToken')
            const Querystring = require('querystring');
            let body = Querystring['stringify']({
                "UserName": localStorage.getItem('userName'),
                "RefreshToken": refreshToken,
                channelID: 'WEB'
            })

            return axiosInstanceFtth.post(refreshTokenUrl, body).then(response => {

                if (response.status === 200) {
                    localStorage.setItem('slt_ftth_accessToken', response.data.access_token)
                    localStorage.setItem('slt_ftth_refreshToken', response.data.refresh_token)
                    axiosInstanceFtth.defaults.headers.common['Authorization'] = 'bearer ' + response.data.access_token;
                    return axiosInstanceFtth(originalRequest);
                } else {
                    logOut()
                    localStorage.removeItem('slt_ftth_accessToken')
                    localStorage.removeItem('slt_ftth_refreshToken')
                    localStorage.removeItem('userImage')
                    window.location.reload()
                }
            }).catch(() => {
                logOut()
                localStorage.removeItem('slt_ftth_accessToken')
                localStorage.removeItem('slt_ftth_refreshToken')
                localStorage.removeItem('userImage')
                window.location.reload()
            })
        }
    }


    return Promise.reject(error);
});


export default connect(null, {logOut})(axiosInstanceFtth);
